import React from 'react'
import { useTranslation } from 'react-i18next'

import { FormikProps } from 'formik'
import { PrimeIcons } from 'primereact/api'
import { Button } from 'primereact/button'

import { Header } from '../../../../../components/Header'
import { AddSupplierFormDto } from '../../data/model'

type Props = {
  isLoading: boolean
  formik: FormikProps<AddSupplierFormDto>
  isRequestRunning: boolean
}

export const Title: React.FC<Props> = ({
  isLoading,
  formik,
  isRequestRunning,
}) => {
  const { t } = useTranslation()

  async function handleClick() {
    await formik.submitForm()
  }

  const actions = (
    <Button
      key="saveBtn"
      label={t('supplier.title.add.add.label')}
      icon={PrimeIcons.CHECK}
      className="w-full"
      onClick={handleClick}
      disabled={!formik.dirty}
      loading={isRequestRunning}
    />
  )

  return (
    <Header
      title={t('supplier.title.add.title')}
      showBackButton={true}
      actions={actions}
      isLoading={isLoading}
    />
  )
}
